(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main')
    .controller('ProductesMainCtrl', ProductesMainCtrl);

  function ProductesMainCtrl() {
    var vm = this;
    vm.ctrlName = 'ProductesMainCtrl';
  }
}());
